import { type SimpleFleetRoutes } from '@/app/services/solution/types/get-simple-fleet';

const fleetRoutes: SimpleFleetRoutes = {
  '1': {
    waypoints: [
      {
        runningGtw: 18_406,
        h3Index: '8a0886474547fff',
        id: 0,
        location: {
          latitude: 59.182_057_381,
          longitude: 17.441_199_303,
          z: 0,
        },
        accessLocation: {
          latitude: 59.182_165_8,
          longitude: 17.441_015_8,
          z: 59,
        },
        stationaryMission: {
          duration: 194,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T15:47:20+02:00',
        departureTime: '2024-10-22T15:50:34+02:00',
        startingSoc: 100,
        endingSoc: 100,
        distanceFromStart: 0,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a0886474647fff',
        id: 1,
        location: {
          latitude: 59.187_090_874,
          longitude: 17.457_097_054,
          z: 0,
        },
        accessLocation: {
          latitude: 59.187_135_9,
          longitude: 17.457_092,
          z: 48,
        },
        stationaryMission: {
          duration: 21,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T15:53:14+02:00',
        departureTime: '2024-10-22T15:53:35+02:00',
        startingSoc: 99.834_76,
        endingSoc: 99.834_76,
        distanceFromStart: 1364.7523,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a088647092ffff',
        id: 2,
        location: {
          latitude: 59.190_285_683,
          longitude: 17.459_227_562,
          z: 0,
        },
        accessLocation: {
          latitude: 59.190_293_5,
          longitude: 17.459_170_6,
          z: 51,
        },
        stationaryMission: {
          duration: 32,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T15:54:50+02:00',
        departureTime: '2024-10-22T15:55:22+02:00',
        startingSoc: 99.723_78,
        endingSoc: 99.723_78,
        distanceFromStart: 1785.4039,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a088656536ffff',
        id: 3,
        location: {
          latitude: 59.247_932_434,
          longitude: 17.166_034_698,
          z: 0,
        },
        accessLocation: {
          latitude: 59.247_909,
          longitude: 17.166_065_9,
          z: 42,
        },
        stationaryMission: {
          duration: 60,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T16:11:39+02:00',
        departureTime: '2024-10-22T16:12:39+02:00',
        startingSoc: 94.693_62,
        endingSoc: 94.693_62,
        distanceFromStart: 20_674.924,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a0886192ca7fff',
        id: 4,
        location: {
          latitude: 59.249_212_265,
          longitude: 17.166_821_48,
          z: 0,
        },
        accessLocation: {
          latitude: 59.249_185_6,
          longitude: 17.166_775_7,
          z: 39,
        },
        stationaryMission: {
          duration: 21,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T16:13:40+02:00',
        departureTime: '2024-10-22T16:14:01+02:00',
        startingSoc: 94.670_39,
        endingSoc: 94.670_39,
        distanceFromStart: 20_895.54,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a0886110637fff',
        id: 5,
        location: {
          latitude: 59.370_927_811,
          longitude: 17.026_634_216,
          z: 0,
        },
        accessLocation: {
          latitude: 59.370_973_4,
          longitude: 17.026_693_6,
          z: 54,
        },
        stationaryMission: {
          duration: 111,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T16:34:54+02:00',
        departureTime: '2024-10-22T16:36:45+02:00',
        startingSoc: 90.1209,
        endingSoc: 90.1209,
        distanceFromStart: 39_344.51,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a088699e427fff',
        id: 6,
        location: {
          latitude: 59.366_465_569,
          longitude: 16.512_427_33,
          z: 0,
        },
        accessLocation: {
          latitude: 59.366_486_6,
          longitude: 16.512_365,
          z: 40,
        },
        stationaryMission: {
          duration: 328,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T17:14:01+02:00',
        departureTime: '2024-10-22T17:19:29+02:00',
        startingSoc: 82.306_11,
        endingSoc: 82.306_11,
        distanceFromStart: 74_071.59,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a08869932c7fff',
        id: 7,
        location: {
          latitude: 59.361_902_237,
          longitude: 16.509_770_393,
          z: 0,
        },
        accessLocation: {
          latitude: 59.361_902,
          longitude: 16.509_774_1,
          z: 44,
        },
        stationaryMission: {
          duration: 30,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T17:21:47+02:00',
        departureTime: '2024-10-22T17:22:17+02:00',
        startingSoc: 82.177_65,
        endingSoc: 82.177_65,
        distanceFromStart: 74_752.484,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a0886c160e7fff',
        id: 8,
        location: {
          latitude: 59.134_840_965,
          longitude: 16.724_928_856,
          z: 0,
        },
        accessLocation: {
          latitude: 59.134_878,
          longitude: 16.724_979_7,
          z: 77,
        },
        stationaryMission: {
          duration: 117,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T17:51:32+02:00',
        departureTime: '2024-10-22T17:53:29+02:00',
        startingSoc: 75.202_58,
        endingSoc: 75.202_58,
        distanceFromStart: 105_507.81,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a0886d9504ffff',
        id: 9,
        location: {
          latitude: 59.056_838_036,
          longitude: 16.588_157_654,
          z: 0,
        },
        accessLocation: {
          latitude: 59.056_773_4,
          longitude: 16.588_203_2,
          z: 54,
        },
        stationaryMission: {
          duration: 125,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T18:09:29+02:00',
        departureTime: '2024-10-22T18:11:34+02:00',
        startingSoc: 72.503_204,
        endingSoc: 72.503_204,
        distanceFromStart: 119_626.96,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a08b3a0c06ffff',
        id: 10,
        location: {
          latitude: 58.997_206_688,
          longitude: 16.208_427_429,
          z: 0,
        },
        accessLocation: {
          latitude: 58.997_207_4,
          longitude: 16.208_417_1,
          z: 74,
        },
        stationaryMission: {
          duration: 90,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T18:38:48+02:00',
        departureTime: '2024-10-22T18:40:18+02:00',
        startingSoc: 66.420_89,
        endingSoc: 66.420_89,
        distanceFromStart: 146_020.42,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a08b3a2b4a7fff',
        id: 11,
        location: {
          latitude: 59.000_745_773,
          longitude: 16.190_002_441,
          z: 0,
        },
        accessLocation: {
          latitude: 59.000_692_3,
          longitude: 16.189_995_6,
          z: 78,
        },
        stationaryMission: {
          duration: 32,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-22T18:43:21+02:00',
        departureTime: '2024-10-22T18:43:53+02:00',
        startingSoc: 66.192_03,
        endingSoc: 66.192_03,
        distanceFromStart: 147_227.61,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a08b14d868ffff',
        id: 12,
        location: {
          latitude: 59.039_336_205,
          longitude: 15.863_755_226,
          z: 0,
        },
        accessLocation: {
          latitude: 59.039_456_4,
          longitude: 15.864_255_8,
          z: 63,
        },
        stationaryMission: {
          duration: 59_419,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-23T11:36:24+02:00',
        departureTime: '2024-10-24T04:06:43+02:00',
        startingSoc: 61.890_865,
        endingSoc: 61.890_865,
        distanceFromStart: 169_858.58,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a08b14db897fff',
        id: 13,
        location: {
          latitude: 59.042_455_673,
          longitude: 15.875_175_476,
          z: 0,
        },
        accessLocation: {
          latitude: 59.042_453_5,
          longitude: 15.875_212_5,
          z: 65,
        },
        stationaryMission: {
          duration: 890,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-24T04:24:47+02:00',
        departureTime: '2024-10-24T04:39:37+02:00',
        startingSoc: 61.564_934,
        endingSoc: 61.564_934,
        distanceFromStart: 171_442.27,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a08b3b75867fff',
        id: 14,
        location: {
          latitude: 59.049_702_644,
          longitude: 15.911_437_035,
          z: 0,
        },
        accessLocation: {
          latitude: 59.049_721_5,
          longitude: 15.911_307_5,
          z: 65,
        },
        stationaryMission: {
          duration: 32,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-24T04:42:59+02:00',
        departureTime: '2024-10-24T04:43:31+02:00',
        startingSoc: 61.055_183,
        endingSoc: 61.055_183,
        distanceFromStart: 173_807.77,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a08b3a0c077fff',
        id: 15,
        location: {
          latitude: 58.996_370_316,
          longitude: 16.207_490_921,
          z: 0,
        },
        accessLocation: {
          latitude: 58.996_333_2,
          longitude: 16.207_471_7,
          z: 74,
        },
        stationaryMission: {
          duration: 166,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-24T05:05:31+02:00',
        departureTime: '2024-10-24T05:08:17+02:00',
        startingSoc: 56.332_66,
        endingSoc: 56.332_66,
        distanceFromStart: 193_618.84,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a08b3a76397fff',
        id: 16,
        location: {
          latitude: 59.026_658_058,
          longitude: 16.213_747_978,
          z: 0,
        },
        accessLocation: {
          latitude: 59.026_658_6,
          longitude: 16.213_699_1,
          z: 79,
        },
        stationaryMission: {
          duration: 44,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-24T05:15:28+02:00',
        departureTime: '2024-10-24T05:16:12+02:00',
        startingSoc: 55.225_655,
        endingSoc: 55.225_655,
        distanceFromStart: 199_181.16,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a088699e427fff',
        id: 17,
        location: {
          latitude: 59.366_503_716,
          longitude: 16.512_475_967,
          z: 0,
        },
        accessLocation: {
          latitude: 59.366_524_5,
          longitude: 16.512_414_2,
          z: 40,
        },
        stationaryMission: {
          duration: 370,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-24T06:07:54+02:00',
        departureTime: '2024-10-24T06:14:04+02:00',
        startingSoc: 44.191_166,
        endingSoc: 44.191_166,
        distanceFromStart: 252_919.38,
        isTransitWaypoint: false,
      },
      {
        runningGtw: 18_406,
        h3Index: '8a088611071ffff',
        id: 18,
        location: {
          latitude: 59.371_372_223,
          longitude: 17.025_532_722,
          z: 0,
        },
        accessLocation: {
          latitude: 59.371_365_9,
          longitude: 17.025_524_9,
          z: 50,
        },
        stationaryMission: {
          duration: 106,
          gtwChange: 0,
        },
        arrivalTime: '2024-10-24T06:48:11+02:00',
        departureTime: '2024-10-24T06:49:57+02:00',
        startingSoc: 36.229_32,
        endingSoc: 36.229_32,
        distanceFromStart: 287_786.88,
        isTransitWaypoint: false,
      },
    ],
    route: {
      startingGtw: 18_406,
      temperature: 10,
    },
    routePoints: [
      {
        routeWaypointId: 0,
        soc: 100,
        distanceFromStart: 0,
        latitude: 59.182_166,
        longitude: 17.441_016,
        z: 58.666_666_666_666_664,
      },
      {
        routeWaypointId: 0,
        soc: 99.994_095,
        distanceFromStart: 4.072_434,
        latitude: 59.182_19,
        longitude: 17.441_07,
        z: 58.25,
      },
      {
        routeWaypointId: 0,
        soc: 99.988_19,
        distanceFromStart: 59.891_22,
        latitude: 59.1824,
        longitude: 17.441_96,
        z: 58,
      },
      {
        routeWaypointId: 0,
        soc: 99.982_285,
        distanceFromStart: 132.667_65,
        latitude: 59.182_61,
        longitude: 17.443_17,
        z: 56.8,
      },
      {
        routeWaypointId: 0,
        soc: 99.976_38,
        distanceFromStart: 170.748_78,
        latitude: 59.182_69,
        longitude: 17.443_82,
        z: 55.6,
      },
      {
        routeWaypointId: 0,
        soc: 99.970_474,
        distanceFromStart: 283.8619,
        latitude: 59.183_64,
        longitude: 17.443_11,
        z: 54.4,
      },
      {
        routeWaypointId: 0,
        soc: 99.964_57,
        distanceFromStart: 292.881_47,
        latitude: 59.183_71,
        longitude: 17.443_03,
        z: 53.4,
      },
      {
        routeWaypointId: 0,
        soc: 99.958_664,
        distanceFromStart: 317.741_15,
        latitude: 59.1839,
        longitude: 17.4428,
        z: 52.4,
      },
      {
        routeWaypointId: 0,
        soc: 99.952_76,
        distanceFromStart: 369.9941,
        latitude: 59.184_33,
        longitude: 17.442_43,
        z: 52.2,
      },
      {
        routeWaypointId: 0,
        soc: 99.946_85,
        distanceFromStart: 399.4312,
        latitude: 59.184_58,
        longitude: 17.442_26,
        z: 52.2,
      },
      {
        routeWaypointId: 0,
        soc: 99.940_95,
        distanceFromStart: 470.3235,
        latitude: 59.1852,
        longitude: 17.441_97,
        z: 52.8,
      },
      {
        routeWaypointId: 0,
        soc: 99.935_04,
        distanceFromStart: 600.999_63,
        latitude: 59.185_37,
        longitude: 17.444_24,
        z: 53.8,
      },
      {
        routeWaypointId: 0,
        soc: 99.929_14,
        distanceFromStart: 675.5812,
        latitude: 59.185_45,
        longitude: 17.445_54,
        z: 54.8,
      },
      {
        routeWaypointId: 0,
        soc: 99.923_23,
        distanceFromStart: 737.1749,
        latitude: 59.185_53,
        longitude: 17.446_61,
        z: 56,
      },
      {
        routeWaypointId: 0,
        soc: 99.917_33,
        distanceFromStart: 764.2129,
        latitude: 59.185_59,
        longitude: 17.447_07,
        z: 56.8,
      },
      {
        routeWaypointId: 0,
        soc: 99.911_42,
        distanceFromStart: 792.964_66,
        latitude: 59.185_67,
        longitude: 17.447_55,
        z: 57,
      },
      {
        routeWaypointId: 0,
        soc: 99.905_52,
        distanceFromStart: 827.8228,
        latitude: 59.185_77,
        longitude: 17.448_13,
        z: 56.2,
      },
      {
        routeWaypointId: 0,
        soc: 99.899_61,
        distanceFromStart: 870.0375,
        latitude: 59.185_86,
        longitude: 17.448_85,
        z: 55.2,
      },
      {
        routeWaypointId: 0,
        soc: 99.893_71,
        distanceFromStart: 970.9258,
        latitude: 59.186,
        longitude: 17.4506,
        z: 53.8,
      },
      {
        routeWaypointId: 0,
        soc: 99.8878,
        distanceFromStart: 1005.990_54,
        latitude: 59.186_09,
        longitude: 17.451_19,
        z: 52.2,
      },
      {
        routeWaypointId: 0,
        soc: 99.8819,
        distanceFromStart: 1024.7677,
        latitude: 59.186_16,
        longitude: 17.451_49,
        z: 50.6,
      },
      {
        routeWaypointId: 0,
        soc: 99.875_99,
        distanceFromStart: 1080.0643,
        latitude: 59.186_37,
        longitude: 17.452_37,
        z: 49.4,
      },
      {
        routeWaypointId: 0,
        soc: 99.870_09,
        distanceFromStart: 1175.3802,
        latitude: 59.186_75,
        longitude: 17.453_87,
        z: 48.4,
      },
      {
        routeWaypointId: 0,
        soc: 99.864_18,
        distanceFromStart: 1238.8086,
        latitude: 59.186_94,
        longitude: 17.454_92,
        z: 47.6,
      },
      {
        routeWaypointId: 0,
        soc: 99.858_28,
        distanceFromStart: 1261.7076,
        latitude: 59.186_99,
        longitude: 17.455_31,
        z: 47.4,
      },
      {
        routeWaypointId: 0,
        soc: 99.852_37,
        distanceFromStart: 1296.2025,
        latitude: 59.187_06,
        longitude: 17.4559,
        z: 47.4,
      },
      {
        routeWaypointId: 0,
        soc: 99.846_466,
        distanceFromStart: 1333.2612,
        latitude: 59.187_12,
        longitude: 17.456_54,
        z: 47.5,
      },
      {
        routeWaypointId: 0,
        soc: 99.840_56,
        distanceFromStart: 1364.7523,
        latitude: 59.187_136,
        longitude: 17.457_092,
        z: 47.666_666_666_666_664,
      },
      {
        routeWaypointId: 1,
        soc: 99.834_76,
        distanceFromStart: 1364.7523,
        latitude: 59.187_136,
        longitude: 17.457_092,
        z: 48,
      },
      {
        routeWaypointId: 1,
        soc: 99.829_216,
        distanceFromStart: 1372.6251,
        latitude: 59.187_14,
        longitude: 17.457_23,
        z: 48,
      },
    ],
    ecCalculation: {
      totalKWh: 245.711_761_503_482_85,
      regeneratedKWh: 40.560_559_820_091_35,
      hvacKWh: 7.913_807_913_284_478_5,
      totalKWhPerKm: 0.853_165_838_553_759_9,
      cycledEnergyKWhKm: 0,
    },
    routeSummary: {
      typicalRouteDuration: 78_369,
      routeLength: 288_732,
    },
    updatedAt: '2025-06-10T14:59:18.584Z',
    longestDrivenDayEnabled: false,
  },
};

export default fleetRoutes;
